import { colors } from './colors';
export var charts = {
  chartsBackgroundColor: colors.background,
  chartsAxisColor: colors.uiL,
  chartsPlotLinesColor: colors.uiL,
  chartsPlotLinesWidth: 1,
  chartsBarBorderRadius: 0,
  chartsBarUpColor: colors.positiveM,
  chartsBarUpBorderColor: colors.positive,
  chartsBarDownColor: colors.negativeM,
  chartsBarDownBorderColor: colors.negative,
  chartsScatterPointColor: colors.primaryL,
  chartsScatterPointColorActive: colors.primary,
  chartsScatterPointRadius: 6,
  chartsScatterPointRadiusActive: 12,
  chartsColors: [colors.primary, colors.secondary, colors.terciary]
};